// extracted by mini-css-extract-plugin
module.exports = {"container":"WaysToEarn__container__jMMQ0","button":"WaysToEarn__button__4ymRe","badgeWrapper":"WaysToEarn__badgeWrapper__aAfOm","opportunities":"WaysToEarn__opportunities__OTUu9"};